var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1005_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1005_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7074 5.29303C23.8949 5.48056 24.0002 5.73487 24.0002 6.00003C24.0002 6.26519 23.8949 6.5195 23.7074 6.70703L14.2074 16.207C14.0199 16.3945 13.7656 16.4998 13.5004 16.4998C13.2352 16.4998 12.9809 16.3945 12.7934 16.207L8.50041 11.914L1.70741 18.707C1.5188 18.8892 1.2662 18.99 1.00401 18.9877C0.741809 18.9854 0.490997 18.8803 0.305589 18.6948C0.12018 18.5094 0.0150115 18.2586 0.0127331 17.9964C0.0104547 17.7342 0.111249 17.4816 0.293407 17.293L7.79341 9.79303C7.98094 9.60556 8.23524 9.50024 8.50041 9.50024C8.76557 9.50024 9.01988 9.60556 9.20741 9.79303L13.5004 14.086L22.2934 5.29303C22.4809 5.10556 22.7352 5.00024 23.0004 5.00024C23.2656 5.00024 23.5199 5.10556 23.7074 5.29303Z",
    fill: "#E84847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C16 5.73478 16.1054 5.48043 16.2929 5.29289C16.4804 5.10536 16.7348 5 17 5H23C23.2652 5 23.5196 5.10536 23.7071 5.29289C23.8946 5.48043 24 5.73478 24 6V12C24 12.2652 23.8946 12.5196 23.7071 12.7071C23.5196 12.8946 23.2652 13 23 13C22.7348 13 22.4804 12.8946 22.2929 12.7071C22.1054 12.5196 22 12.2652 22 12V7H17C16.7348 7 16.4804 6.89464 16.2929 6.70711C16.1054 6.51957 16 6.26522 16 6Z",
    fill: "#E84847"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUpRed);
export default __webpack_public_path__ + "static/media/trend_up_red.d79f67053bd5c46139ad39370f79e38c.svg";
export { ForwardRef as ReactComponent };